// import React from "react";
// import { useGlobalState } from "../GlobalProvider";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { useNavigate } from "react-router-dom";
// function TopNav() {
//   const navigate = useNavigate();
//   const { globalState, setGlobalState } = useGlobalState();

//   const handleLogoutFunc = () => {
//     const confirmed = window.confirm("Are you sure you want to logout?");
//     if (confirmed) {
//       setGlobalState({
//         user: null,
//         token: null,
//         permissions: null,
//       });
//       toast.success("Admin logged out successfully");
//       localStorage.removeItem("token");
//       localStorage.removeItem("user");
//       localStorage.removeItem("permissions");
//       navigate("/");
//     }
//   };
//   return (
//     <div className="topNavMain p-3  p-md-4 ">
//       <div className="d-flex justify-content-between align-items-center">
//         <img
//           src="https://cdn-icons-png.flaticon.com/128/2976/2976215.png"
//           onClick={() =>
//             setGlobalState({
//               ...globalState,
//               showFullSidebar: !globalState.showFullSidebar,
//             })
//           }
//           className="barIcon"
//         />
//         <div className="d-flex align-items-center navRightDiv">
//           <div className="me-3 notificationDiv d-flex">
//             <img src="https://cdn-icons-png.flaticon.com/128/3602/3602123.png" />
//             <p>2</p>
//           </div>
//           <div
//             className="d-flex align-items-center me-0 me-md-4"
//             style={{ cursor: "pointer" }}
//           >
//             <img
//               src={globalState?.user?.profilePic}
//               style={{ borderRadius: "50%" }}
//             />
//             <p className="mb-0 ms-2  text-bold" style={{ color: "white" }}>
//               {[globalState?.user?.firstName, globalState?.user?.lastName]
//                 .filter(Boolean)
//                 .join(" ") || "Guest"}
//             </p>
//             <img
//               src="https://cdn-icons-png.flaticon.com/128/18387/18387745.png"
//               style={{
//                 borderRadius: "50%",
//                 height: "20px",
//                 width: "20px",
//                 filter: "brightness(0) invert(1)",
//               }}
//               className="ms-3"
//               onClick={() => handleLogoutFunc()}
//             />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default TopNav;

import React from "react";
import { useGlobalState } from "../GlobalProvider";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

function TopNav({ pageTitle = "Dashboard", pagePath = "Home / Dashboard" }) {
  const navigate = useNavigate();
  const { globalState, setGlobalState } = useGlobalState();

  const handleLogoutFunc = () => {
    const confirmed = window.confirm("Are you sure you want to logout?");
    if (confirmed) {
      setGlobalState({
        user: null,
        token: null,
        permissions: null,
      });
      toast.success("Admin logged out successfully");
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("permissions");
      navigate("/");
    }
  };

  const fullName =
    [globalState?.user?.firstName, globalState?.user?.lastName]
      .filter(Boolean)
      .join(" ") || "Admin";

  const initials = fullName
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);

  return (
    <div className="topNavMain">
      <div className="tn-inner">
        {/* Left — hamburger + page title */}
        <div className="tn-left">
          <button
            className="tn-hamburger"
            aria-label="Toggle sidebar"
            onClick={() =>
              setGlobalState({
                ...globalState,
                showFullSidebar: !globalState.showFullSidebar,
              })
            }
          >
            <i className="ti ti-menu-2" aria-hidden="true" />
          </button>
          <div className="tn-page-info">
            <div className="tn-page-title">{pageTitle}</div>
            <div className="tn-page-path">{pagePath}</div>
          </div>
        </div>

        {/* Right — notification + user + logout */}
        <div className="tn-right">
          {/* Notification bell */}
          <div className="tn-icon-btn" title="Notifications">
            <i className="ti ti-bell" aria-hidden="true" />
            <span className="tn-badge" />
          </div>

          <div className="tn-divider" />

          {/* User chip */}
          <div className="tn-user-chip">
            <div className="tn-avatar">
              {globalState?.user?.profilePic ? (
                <img src="https://cdn-icons-png.flaticon.com/128/15735/15735364.png" alt={fullName} />
              ) : (
                initials
              )}
            </div>
            <div className="tn-user-text">
              <div className="tn-user-name">Big Bang</div>
              <div className="tn-user-role">Super Admin</div>
            </div>
          </div>

          {/* Logout */}
          <button
            className="tn-logout-btn"
            title="Logout"
            onClick={handleLogoutFunc}
            aria-label="Logout"
          >
            <i className="ti ti-logout" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  );
}

export default TopNav;